<div class="m-5">
  <p class="font-medium text-2xl mb-1">
    Problem Template Preview
  </p>
  <hr />
  <div class="flex justify-end mt-2">
    <outline-button (click)="exitPreview()" text="Exit Preview"/>
  </div>
  <div [style]="previewDivStyle">
    @if (problem_template != null) {
      <div>
        <div class="mb-1">
          @if (checkForHTMLTags(problem_template.question_text)) {
            <div [innerHTML]="problem_template.question_text"></div>
          }
          @if (!checkForHTMLTags(problem_template.question_text)) {
            <div [innerText]="problem_template.question_text"></div>
          }
          @if (problem_template.mathjax) {
            <p [mathjax]="problem_template.question_text" class="mb-6"></p>
          }
        </div>
        @if (problem_template.type === 'MULTIPLECHOICE') {
          <div>
            @if (problem_template.audio != null) {
              <div>
                @for (audio of problem_template.audio; track audio) {
                  <div class="mt-2">
                    <audio-playback [audio_url]="audio.source"/>
                  </div>
                }
              </div>
            }
            <multiple-choice [problem_template]="problem_template" />
          </div>
        }
        @if (problem_template.type === 'DECIMAL' || problem_template.type === 'INTEGER') {
          <div>
            <decimal [(answer)]="answer" />
          </div>
        }
        @if (problem_template.type === 'TEXTAREA') {
          <div>
            <text-area [(answer)]="answer" />
          </div>
        }
        @if (problem_template.type === 'CANVAS') {
          <div>
            <div>
              NOTE: Canvas is known to not work properly at the moment
            </div>
            <drawable-canvas></drawable-canvas>
          </div>
        }
        @if (problem_template.type === '3D') {
          <div>
            <!-- TODO need to make only one checkbox selectable -->
            @for (value of problem_template.values; track value) {
              <div>
                <mat-checkbox [value]="value.value">{{value.formatted}}</mat-checkbox>
              </div>
            }
            @if (problem_template.answer_infix != undefined) {
              <div class="my-1">
                {{problem_template.answer_infix}}
              </div>
            }
            @for (reason of problem_template.reasons; track reason) {
              <div>
                <mat-checkbox [value]="reason.value">{{reason.formatted}}</mat-checkbox>
              </div>
            }
          </div>
        }
        @if (problem_template.type === 'MULTIFIELD') {
          <div>
            <multifield [problem_template]="problem_template" />
          </div>
        }
        @if (problem_template.type === 'FORMULA') {
          <div>
            <formula />
          </div>
        }
        @if (problem_template.type === 'GROUPING') {
          <div>
            <grouping [problem_template]="problem_template" [(answer)]="answer" />
          </div>
        }
        @if (problem_template.type === 'ORDERING') {
          <div>
            @for (item of problem_template.details.allItems; track item) {
              <div>
                {{item.formatted}}
              </div>
            }
            <div>
              Type the numbers in the text box seperated by commas in the correct order
            </div>
            <input placeholder="Enter order" class="mt-1" />
          </div>
        }
        @if (problem_template.type === 'UPLOAD_DOC') {
          <div>
            <file-upload [file_extensions]="problem_template.upload_extensions || []" />
          </div>
        }
        @if (problem_template.type === 'RECORD_AUDIO') {
          <div>
            <audio-record />
          </div>
        }
        @if (problem_template.type === 'PASSAGE') {
          <div>
            <multifield [problem_template]="problem_template" />
          </div>
        }
        @if (problem_template.type === 'REGEX') {
          <div>
            <text-area [(answer)]="answer" />
          </div>
        }
        @if (problem_template.type === 'PROGRAMMING') {
          <div>
            <code-editor [answerSkeleton]="problem_template.answerSkeleton" [sampleCases]="problem_template.sampleCases" [samplesRemaining]="problem_template.samplesRemaining" />
          </div>
        }
      </div>
    }
  </div>
</div>
